import moment from 'moment';
import 'moment/locale/uk';
import 'moment/locale/en-gb';

export const setupMomentLocales = () => {
  moment.updateLocale('uk', {
    monthsShort: [
      'січ.', 'лют.', 'бер.', 'квіт.', 'трав.', 'черв.',
      'лип.', 'серп.', 'вер.', 'жовт.', 'лист.', 'груд.',
    ],
  });

  moment.updateLocale('en', {
    monthsShort: [
      'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.',
      'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.',
    ],
  });
};
